export const kmPerMile = 1.60934
export const milePerKm = 1 / kmPerMile